import { Heading } from "@chakra-ui/react";
import React from "react";

const PrimaryHeading = (props) => {
  return <Heading fontWeight="bold" color="primary.1" size="md" {...props} />;
};

export default PrimaryHeading;
